export const UploadDataWindowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M14 21.708H4C3.46957 21.708 2.96086 21.4973 2.58579 21.1222C2.21071 20.7471 2 20.2384 2 19.708V5.70801C2 5.17757 2.21071 4.66887 2.58579 4.29379C2.96086 3.91872 3.46957 3.70801 4 3.70801H20C20.5304 3.70801 21.0391 3.91872 21.4142 4.29379C21.7893 4.66887 22 5.17757 22 5.70801V14.708"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2 7.70803H22M5 5.71803L5.01 5.70703M8 5.71803L8.01 5.70703M11 5.71803L11.01 5.70703M19.5 22.708V16.708M19.5 16.708L17 19.208M19.5 16.708L22 19.208"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
